import type { GroupingMode } from './TimeEntryList';

interface GroupingToggleProps {
  value: GroupingMode;
  onChange: (mode: GroupingMode) => void;
}

export function GroupingToggle({ value, onChange }: GroupingToggleProps) {
  return (
    <div className="inline-flex rounded-lg bg-gray-100 p-0.5">
      <button
        onClick={() => onChange('project')}
        className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${
          value === 'project'
            ? 'bg-white text-gray-900 shadow-sm'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        By Project
      </button>
      <button
        onClick={() => onChange('day')}
        className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${
          value === 'day'
            ? 'bg-white text-gray-900 shadow-sm'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        By Day
      </button>
    </div>
  );
}
